import OrderCloudModel from '../ordercloud/index.model.js';
import requestProps from './requestProps.js';
const model = {
    name: 'OCSearchRequest',
    file: 'OCSearchRequest',
    buildInterface: true,
    properties: {
        ...requestProps,
        ordercloud: {
            type: 'model',
            model: OrderCloudModel,
            setter: 'setOrderCloudContext',
            getter: 'getOrderCloudContext',
        },
    },
};
export default model;
